import { Box } from "@mui/material";
import React from "react";

/** Full-page shell for `/ad/*` routes — no site menu or MinimalHeader. */
export default function AdvertisementLayout({ children, variant = "dark" }) {
    const light = variant === "light";

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: light ? "#ffffff" : "#07080c",
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >
            {children}
        </Box>
    );
}
